
/**
 * Maximum number of EV's 
 */
export const limitEV = 40; 